import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Card, Col, Image, Row } from "react-bootstrap";
import productImg from "../../../assets/images/product-image.svg";
import {
  useGetHeliorOneQuery,
  useGetHeliorPlanQuery,
} from "../../../app/features/apiSlice";
import Loader from "../../../components/Loader";
import { setPageTitle } from "../../../app/features/DataSlice";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Error from "../../../components/Error";
import { useGetKYCStatusQuery } from "../../../app/features/apiSlice";
import KycCard from "../../../components/kyc/KycCard";
// import SharingPackCard from "../../../components/SharingPackCard";
import { setProductData } from "../../../app/features/ProductSlice";

const Products = () => {
  const pageTitle = "products";
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { lang } = useParams();
  const sessionId = useRef(Date.now()).current;
  const getKYCStatus = useGetKYCStatusQuery({ sessionId });

  const {
    data: heliorOne,
    isSuccess: isHOSuccess,
    isLoading: isLoading1,
    isError: isError1,
    error: error1,
  } = useGetHeliorOneQuery({
    sessionId,
  });

  const {
    data: heliorPlan,
    isSuccess: isHPSuccess,
    isLoading: isLoading2,
    isError: isError2,
    error: error2,
  } = useGetHeliorPlanQuery({
    sessionId,
  });

  useEffect(() => {
    dispatch(setPageTitle(t(`${pageTitle}`)));
    dispatch(setProductData({}));
    // eslint-disable-next-line
  }, [t]);

  if (getKYCStatus.isLoading) return <Loader />;

  if (getKYCStatus?.data?.userStatus?.open_kyc) {
  return (
    <div className="mt-3">
      <h4 className="heading mb-3">{t(pageTitle)}</h4>

      <Row>
        <Col md={12}>
          <KycCard kycStatusKey={getKYCStatus.data} />
        </Col>
      </Row>
    </div>
  );
}

  return (
    <div className="mt-3">
      <h4 className="heading mb-3">{t(`${pageTitle}`)}</h4>
      <h5 className="subheading mb-3 text-light">{t("heliorAccumulation")}</h5>

      {/* Show KYC card only when kycRange is present (user has upgraded/invested) */}
      {getKYCStatus?.data?.kycRange && (
        <Row>
          <Col md={12}>
            <KycCard kycStatusKey={getKYCStatus.data} />
          </Col>
        </Row>
      )}

      <Row className="m3-5">
        {(isLoading1 || isLoading2) && <Loader />}
        {isError1 && <Error error={error1} />}
        {isError2 && <Error error={error2} />}
        {isHPSuccess && (
          <Col lg={4} md={6} className="mb-3">
            <Card className="p-3 h-100 products" bg="dark1 text-light">
              <Card.Body className="d-flex flex-column justify-content-between">
                <div>
                  <Card.Title className="mb-4 fs-2">
                    <div className="d-flex flex-row align-items-center gap-2 mb-2 mb-lg-4">
                      <Image
                        src={productImg}
                        className="img-fluid"
                        alt={"X-Plan"}
                      />
                      {/* <h4 className="title">{heliorPlan?.data?.name}</h4> */}
                      <h4 className="title text-white fs-2">X-PLAN</h4>
                    </div>
                    <p className="sub-title">
                      {JSON.parse(heliorPlan?.data?.description)[lang]}
                    </p>
                  </Card.Title>
                  <div className="mb-4">
                    <p className="price-title">{t("startingFrom")}</p>
                    <span className="price">
                      {heliorPlan?.data?.amount} {heliorPlan?.data?.display}
                    </span>
                    <span className="unit">/ {t("perMonth")}</span>
                  </div>
                  <hr />
                  <ul className="mt-auto list-unstyled icon-list">
                    {JSON.parse(heliorPlan?.data?.benefit)[lang].map(
                      (item, i) => (
                        <li key={i}>
                          <i className="fa-regular fa-circle-check h6 text-gold pe-2"></i>
                          {item}
                        </li>
                      )
                    )}
                  </ul>
                </div>
                <Link
                  className="btn btn-primary-outline"
                  to={`/${lang}/products/excelior-plan/${heliorPlan?.data?.id}`}
                >
                  {t("choosePlan")}
                </Link>
              </Card.Body>
            </Card>
          </Col>
        )}
        {isHOSuccess && (
          <Col lg={4} md={6} className="mb-3">
            <Card className="p-3 h-100 products" bg="dark1 text-light">
              <Card.Body className="d-flex flex-column justify-content-between">
                <div>
                  <Card.Title className="mb-4 fs-2">
                    <div className="d-flex flex-row align-items-center gap-2 mb-2 mb-lg-4">
                      <Image
                        src={productImg}
                        className="img-fluid"
                        alt={"X-One"}
                      />
                      <h4 className="title text-white fs-2">X-ONE</h4>
                    </div>
                    <p className="sub-title">
                      {JSON.parse(heliorOne?.data?.description)[lang]}
                    </p>
                  </Card.Title>
                  <div className="mb-4">
                    <p className="price-title">{t("startingFrom")}</p>
                    <span className="price text-lowercase">
                      {heliorOne?.data?.amount} {heliorOne?.data?.display}
                    </span>
                  </div>
                  <hr />
                  <ul className="mt-auto list-unstyled icon-list">
                    {JSON.parse(heliorOne?.data?.benefit)[lang].map(
                      (item, i) => (
                        <li key={i}>
                          <i className="fa-regular fa-circle-check h6 text-gold pe-2"></i>
                          {item}
                        </li>
                      )
                    )}
                  </ul>
                </div>
                <Link
                  className="btn btn-primary-outline"
                  to={`/${lang}/products/excelior-one/${heliorOne?.data?.id}`}
                >
                  {t("choosePlan")}
                </Link>
              </Card.Body>
            </Card>
          </Col>
        )}
        {/* <SharingPackCard /> */}
      </Row>
    </div>
  );
};

export default Products;
